var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "contest-entry-novel-select-overlay",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onCancel.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-label": _vm.title,
          },
        },
        [
          _c("div", { staticClass: "modal-header" }, [
            _c("h2", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
            _c(
              "button",
              {
                staticClass: "close-button",
                attrs: { type: "button", "aria-label": _vm.$t("common.close") },
                on: { click: _vm.onCancel },
              },
              [_c("IconClose", { staticClass: "close-icon" })],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _vm.loading
                ? _c("LoadingSpinner", {
                    attrs: { size: "small", variant: "inline" },
                  })
                : _vm.listItems.length === 0
                ? _c("p", { staticClass: "empty-message" }, [
                    _vm._v(
                      _vm._s(_vm.$t("contestEntryForm.step2.novelSelect.empty"))
                    ),
                  ])
                : _c(
                    "ul",
                    { staticClass: "novel-list" },
                    _vm._l(_vm.listItems, function (item) {
                      return _c("li", { key: item.novelId }, [
                        _c(
                          "button",
                          {
                            staticClass: "novel-item",
                            class: {
                              selected: _vm.selectedNovelId === item.novelId,
                            },
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.onSelectNovel(item.novelId)
                              },
                            },
                          },
                          [
                            _c("ImageView", {
                              staticClass: "novel-cover",
                              attrs: { src: item.image },
                            }),
                            _c("div", { staticClass: "novel-meta" }, [
                              _c("p", { staticClass: "novel-title" }, [
                                _vm._v(_vm._s(item.title)),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ])
                    }),
                    0
                  ),
            ],
            1
          ),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "confirm-button",
                attrs: { type: "button", disabled: !_vm.selectedNovelId },
                on: { click: _vm.onConfirm },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("contestEntryForm.step2.novelSelect.confirm")
                    ) +
                    " "
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "cancel-button",
                attrs: { type: "button" },
                on: { click: _vm.onCancel },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("contestEntryForm.step2.novelSelect.cancel")
                    ) +
                    " "
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }